import { render, staticRenderFns } from "./topData.vue?vue&type=template&id=15dd5f46&scoped=true"
import script from "./topData.vue?vue&type=script&lang=js"
export * from "./topData.vue?vue&type=script&lang=js"
import style0 from "./topData.vue?vue&type=style&index=0&id=15dd5f46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dd5f46",
  null
  
)

export default component.exports